"use client";

import { c as _c } from "react/compiler-runtime";
import { AssignmentReturn, DateRange, Logout, PermContactCalendar, PersonPin } from "@mui/icons-material";
import { Divider } from "@mui/material";
import Link from "next/link";
import React, { useState } from "react";
import styled from "styled-components";
import { Button, ButtonVariant, Text, TextColor, TextSize, TextWeight } from "../../components";
const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;
const DropdownButton = styled.div`
  width: 50px;
  height: 40px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  tracking-widest;

  p {
    text-align: center;
    width: 75px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
const DropdownContent = styled.div`
  position: absolute;
  right: 0;
  top: 135%;
  width: 320px;
  background-color: white;
  border: 1px solid #e0e0e0;
  z-index: 20;
  box-shadow: ${({
  theme
}) => theme.shadows.box};
  opacity: ${props => props.$isVisible ? 1 : 0};
  visibility: ${props => props.$isVisible ? "visible" : "hidden"};
  transition:
    opacity 0.2s ease,
    visibility 0.2s ease;
`;
const MenuItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0;
  cursor: pointer;

  svg {
    fill: ${({
  theme
}) => theme.colors.GRAYSCALE_700};
  }

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f9f9f9;
  }
`;
const MenuIcon = styled.div`
  margin-right: 16px;
`;
export const AccountDropdown = t0 => {
  const $ = _c(20);
  const {
    icon,
    logout,
    isLoggedIn: t1,
    userName: t2
  } = t0;
  const isLoggedIn = t1 === undefined ? false : t1;
  const userName = t2 === undefined ? "" : t2;
  const [isVisible, setIsVisible] = useState(false);
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsVisible(true);
    t4 = () => setIsVisible(false);
    $[0] = t3;
    $[1] = t4;
  } else {
    t3 = $[0];
    t4 = $[1];
  }
  const t5 = isLoggedIn ? "/moje-konto" : "/logowanie";
  const t6 = isLoggedIn ? userName : "Konto";
  let t7;
  if ($[2] !== t6) {
    t7 = <Text text={t6} color={TextColor.BLACK} fontSize={TextSize.XXS} weight={TextWeight.BOLD} textTransform="uppercase" />;
    $[2] = t6;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== icon || $[5] !== t7) {
    t8 = <DropdownButton className="flex flex-row gap-1 items-center tracking-widest">{icon}{t7}</DropdownButton>;
    $[4] = icon;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== t5 || $[8] !== t8) {
    t9 = <Link href={t5}>{t8}</Link>;
    $[7] = t5;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== isLoggedIn || $[11] !== logout || $[12] !== userName) {
    t10 = isLoggedIn ? <><div className="p-4"><Text text={`${userName},`} color={TextColor.BLACK} fontSize={TextSize.L} weight={TextWeight.BOLD} className="mb-1" /><Text text={"mi\u0142o, \u017Ce jeste\u015B z nami!"} color={TextColor.BLACK} fontSize={TextSize.S} weight={TextWeight.NORMAL} /></div><Divider /><div className="p-4"><Link href="/historia-zamowien"><MenuItem><MenuIcon><DateRange /></MenuIcon><Text text={"Historia zam\xF3wie\u0144"} color={TextColor.BLACK} fontSize={TextSize.S} weight={TextWeight.NORMAL} /></MenuItem></Link><Link href="/zwroty-produktow"><MenuItem><MenuIcon><AssignmentReturn /></MenuIcon><Text text={"Zwroty produkt\xF3w"} color={TextColor.BLACK} fontSize={TextSize.S} weight={TextWeight.NORMAL} /></MenuItem></Link><Link href="/dane-osobiste"><MenuItem><MenuIcon><PermContactCalendar /></MenuIcon><Text text="Moje dane" color={TextColor.BLACK} fontSize={TextSize.S} weight={TextWeight.NORMAL} /></MenuItem></Link><Link href="/adresy"><MenuItem><MenuIcon><PersonPin /></MenuIcon><Text text="Moje adresy" color={TextColor.BLACK} fontSize={TextSize.S} weight={TextWeight.NORMAL} /></MenuItem></Link><MenuItem onClick={logout}><MenuIcon><Logout /></MenuIcon><Text text="Wyloguj" color={TextColor.BLACK} fontSize={TextSize.S} weight={TextWeight.NORMAL} /></MenuItem></div></> : <div className="p-4"><Text text={"Jeste\u015B ju\u017C u\u017Cytkownikiem?"} color={TextColor.BLACK} fontSize={TextSize.L} weight={TextWeight.NORMAL} className="mb-4" /><Link href="/logowanie" className="mb-4"><Button variant={ButtonVariant.PRIMARY} text={"ZALOGUJ SI\u0118"} className="!w-full" onClick={() => setIsVisible(false)} /></Link><Text text={"Jeste\u015B tu pierwszy raz?"} color={TextColor.BLACK} fontSize={TextSize.L} weight={TextWeight.NORMAL} className="mt-8 mb-4" /><Link href="/rejestracja"><Button variant={ButtonVariant.SECONDARY} text={"ZAREJESTRUJ SI\u0118"} className="!w-full" onClick={() => setIsVisible(false)} /></Link></div>;
    $[10] = isLoggedIn;
    $[11] = logout;
    $[12] = userName;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== isVisible || $[15] !== t10) {
    t11 = <DropdownContent $isVisible={isVisible}>{t10}</DropdownContent>;
    $[14] = isVisible;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t9) {
    t12 = <DropdownContainer onMouseEnter={t3} onMouseLeave={t4}>{t9}{t11}</DropdownContainer>;
    $[17] = t11;
    $[18] = t9;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
};
export default AccountDropdown;